<template>
    <div class="scenic-list" :class="{showAll: showAllScenicList}" v-if="initSuccess" @click="showAllScenicList = !showAllScenicList">
        <div class="current-item">{{ currentScenic.title }}</div>
        <div class="list">
            <div class="item" :class="{active: item.select}" v-for="item in showScenicList" :key="item.id" @click.stop.prevent="gotoScenic(item)">{{ item.title }}</div>
        </div>
    </div>
</template>

<script>
import Apis from '../../config/apis'
import _ from '../../config/util'
export default {
    data () {
        return {
            sid: this.$route.query.id || '',
            scenicList: [],
            showAllScenicList: true,
            cityData: {
                id:'',
                title: '野三坡景区'
            },
            initSuccess: false,
        }
    },
    computed: {
        isWeiXin() {
            return this.$store.state.isWeiXin
        },
        showScenicList() {
            return this.scenicList.map(v => {
                v.select = v.id == this.sid
                return v
            })
        },
        currentScenic() {
            return this.scenicList.find(v => v.id == this.sid) || this.cityData
        }
    },
    mounted() {
        this.getScenicList()

        window._this1 = this
    },
    methods: {
        getScenicList() {
            this.axios.post(Apis.scenicList, {
                key: 'scenic',
                map: 1,
                limit: 999
            }).then(res => {
                this.scenicList = [this.cityData, ...res.data]
                this.initSuccess = true
            })
        },
        gotoScenic(item) {
            console.info('gotoScenic1', item)
            if(item.select) {
                this.showAllScenicList = false
                return
            }
            console.info('gotoScenic2')

            const userLocationMarker = this.$store.state.userLocationMarker
            const map = this.$store.state.mapObj
            // 如果头定位点清楚掉当前地图的定位点
            if (userLocationMarker != '') {
                map.remove([userLocationMarker])
                this.$store.commit('setUserLocationMarker', '')
            }


            console.info('实际刷新')
            let query = {
                ...this.$route.query,
                id: item.id
            }
            let refresh = () => {
                this.$router.replace({
                    path: '/',
                    query
                })
            }

            // 触发刷新机制
            if(this.$route.path != '/map') {
                console.info('重定向')
                this.$router.replace({
                    path: 'map'
                }).then(() => {
                    refresh()
                })
            } else refresh()
            // this.$router.replace({
            //     path: '/',
            //     query: {
            //         ...this.$route.query,
            //         id: item.id
            //     }
            // }).then(res => {
            //     console.info('gotoScenic3', res)
            //     if (navigator.userAgent.includes('iPhone')) { // iOS 设备
            //         console.info('IOS刷新')
            //         window.location.href = window.location.href
            //     } else { // 其他设备
            //         console.info('安卓刷新')
            //         this.$router.go(0)
            //     }
            // }).catch(e => {
            //     console.info(e,'------')
            //     console.info('gotoScenic4', e)
            // })
        }
    }
}
</script>

<style lang="scss" scoped>

.scenic-list {
    position: fixed;
    top: 250px;
    left: 0px;
    // box-sizing: border-box;
    z-index: 2;
    background: #FDFDFD;
    width: .6rem;
    --box-icon: url('https://scenic.tuliyou.com/upload/uediter/image/20250121/1737450572767734.png');
    
    .item {
        display: none;
    }
    &.showAll {
        width: fit-content;
        min-width: 1.84rem;
        --box-icon: url('https://scenic.tuliyou.com/upload/uediter/image/20250121/1737450572195816.png');
        .current-item {
            display: none;
        }
        .item {
            display: block;
        }
    }
    &::after {
        content: '';
        width: .24rem;
        height: 100%;
        background: var(--box-icon) center / .12rem .18rem no-repeat, #206864;
        border-radius: 0 .28rem .28rem 0;
        position: absolute;
        top: 0;
        right: 0;
        transform: translateX(100%);
    }
    .current-item {
        font-weight: 500;
        font-size: .26rem;
        color: #121212;
        padding: .16rem .16rem;
    }
    .list {
        max-height: 50vh;
        overflow-y: auto;
    }
    .item {
        font-weight: 500;
        font-size: .24rem;
        color: #666666;
        padding: .2rem .2rem;
        white-space: nowrap;
        &.active {
            color: #121212;
            position: relative;
            &::after {
                content: '';
                width: calc(100% - .12rem);
                height: .06rem;
                background: #206864;
                position: absolute;
                left: 50%;
                bottom: 0.06rem;
                transform: translateX(-50%);
            }
        }
    }
}
</style>